
import { NotArrivedView } from "../views/notArrivedView.jsx";
import { useParams } from "react-router-dom";
import locationTask from "../data/locationTask.json";
import images from "../images/images.js";

function NotArrived() {
  const { id } = useParams();
  const location = locationTask[id];
    const imageKey = `drawing_${id}`;

  // Handle Yes / No button presses
  function handleGoBackACB() {
    window.location.hash = `#/mapOverview`;
  }

  function handleProceedAnywayACB() {
    window.location.hash = `#/modeSelection/${id}`;
  }

  if (!location) {
    return <div>Location not found 😕</div>;
  }

  return (
    <NotArrivedView
      locationTitle={location.title}
      onGoBack={handleGoBackACB}
      onProceed={handleProceedAnywayACB}
      imageKey={imageKey}
    />
  );
}

export { NotArrived };

